import styled from 'styled-components';
import { editorTheme } from '../../theme';

export const ToolButton = styled.button<{ active?: boolean }>`
  width: 32px;
  height: 32px;
  flex: none;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ active }) => (active ? editorTheme.accentSoft : 'none')};
  color: ${({ active }) =>
    active ? editorTheme.accentHover : editorTheme.text};
  &:hover:not(:disabled) {
    background: ${({ active }) =>
      active ? editorTheme.accentSoft : editorTheme.surfaceMuted};
  }
  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
`;

export const Separator = styled.span`
  width: 1px;
  height: 24px;
  flex: none;
  margin: 0 6px;
  background: ${editorTheme.border};
`;
